import script from "./PrivateNav.vue?vue&type=script&setup=true&lang=js"
export * from "./PrivateNav.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__